import React from 'react';
import {
  buttonContainerCX,
  buttonPlaceholderCX,
  detailedInfoTextSkeletonCX,
  getDetailedInfoContainerCX,
  getHeroPhotoContainerCX,
  getListingCardContainerCX,
  priceSkeletonCX,
  skeletonWrapperCX,
} from './styles';

type ListingCardV3SkeletonProps = {
  displayName?: string;
};

const ListingCardV3Skeleton = ({ displayName = '' }: ListingCardV3SkeletonProps) => {
  return (
    <div className={skeletonWrapperCX} data-name="SkeletonWrapper">
      <article className={getListingCardContainerCX({})} data-name="ListingCardContainer">
        <figure className={getHeroPhotoContainerCX({ isLoading: true })} data-name="HeroPhotoContainerSkeleton" />
        <section className={getDetailedInfoContainerCX({})} data-name="DetailedInfoContainer">
          <div className={priceSkeletonCX} data-name="PriceSkeleton" />
          <div className={detailedInfoTextSkeletonCX} data-name="DetailedInfoTextSkeleton" />
          {displayName ? (
            <h3>{displayName}</h3>
          ) : (
            <div className={detailedInfoTextSkeletonCX} data-name="DetailedInfoTextSkeleton" />
          )}
          <div className={detailedInfoTextSkeletonCX} data-name="DetailedInfoTextSkeleton" />
        </section>
        <div className={buttonContainerCX}>
          <div className={buttonPlaceholderCX} />
        </div>
      </article>
    </div>
  );
};

export default ListingCardV3Skeleton;
